import {useEffect, useState} from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Box,TextField,Tooltip,FormControl,//Select as MaterialSelect ,
        FormLabel,FormControlLabel,RadioGroup,Radio,
        InputLabel,Select,MenuItem,Typography} from '@material-ui/core'  
import axios from 'axios';
import qs from 'qs';
import {ErrorGeneral, llamaApiCargaToken, llamadaApiToken} from "../funciones/ClienteAxios";
import { useHistory } from "react-router-dom";
import {toast} from "react-toastify";
import Modal from '../Generales/Modal2';

const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '20ch',
      }, 
      formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
      },
      selectEmpty: {
        marginTop: theme.spacing(2),
      },
      Textnumero: {
        width: 5+"px",
      },
      formControlFull: {
        //margin: theme.spacing(1),
        //minWidth: 120,
        width:5+"rem"
      },
      margin: {
        margin: theme.spacing(1),
      },
    },
  }));
  
const EditarStatusUsu = ({modalAbierto,setModalAbierto ,titulo, actualizar, usrSelecc }) => {
    let history = useHistory();
    const classes = useStyles();
    const idusu = localStorage.getItem('UsuId');
    const[nvoCliente,setNvoCliente]= useState({idUsu:'',stdUsu:'' });                                                    
    const [espera,setEspera]= useState(false);
    const [mensaje, setMensaje] = useState("");
    const [tipoAdvertencia, setTipoAdvertencia] = useState("success");
    const [btnDeshabilitado,setBtnDeshabilitado]= useState(false)
    const [aviso, setAviso] = useState(false);
    const[cambioEfectivo,serCambioEfectivo] = useState(false)    
    const{idUsu,stdUsu}=nvoCliente
    //let colorCheckR='#0EA7E0'
    const source = axios.CancelToken.source();  
    const [usuarioEditado, setUsuarioEditado] = useState({Id:0, Nombre:"", Puesto:"", Terminal:0, Tipo:0, Turno:0, Pass:"", telefono:"", Estatus:0, Usuario:""})
    const {Id, Nombre, Puesto, Terminal, Tipo, Turno, Pass, telefono, Estatus, Usuario} = usuarioEditado    
    useEffect(()=>{
      setUsuarioEditado({...usuarioEditado, Id:usrSelecc.Id, Estatus:usrSelecc.Status, Nombre: usrSelecc.Nombre, })
        //userData()
    },[])

   
     const getEditarUsuario = () => {
        const data = qs.stringify({
            llave: Id,                        
            estatus: Estatus ===1 ? 0 :1,                        
            UsrId:idusu,            
            idDispositivo: 'rjvikcmkcmsdkdcdsmc'
        });
           
        const url = "/usuario/v1/status/edit" ;

        function response(auxiliar) {
            let mensaje ="Error al editar usuario"
            
            if (auxiliar.respuesta == 1) 
            {   mensaje = "Se edito correctamente el usuario"
                setTipoAdvertencia("success")
                setMensaje(mensaje);
                setAviso(true)
                setBtnDeshabilitado(true)
                setModalAbierto(false)
                actualizar()                                               
            }               
            
            toast.success(mensaje, {
                toastId: `edit-user-pil${Id}`,
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }

        llamaApiCargaToken(   data  , 
            url, response, ErrorGeneral, setEspera, history, source);
    }          

    const mandaAlerta=(mensaje,tipoAdvert)=>
    {
        setMensaje(mensaje);
        setTipoAdvertencia(tipoAdvert)  
        setAviso(true);      
    }

    function guardarDatos(e)
    {   e.preventDefault()
        //console.log("guardando  modal");    
     
        getEditarUsuario( )                                                   
    }   

    const DatosGenerales=(
        <div>            
            <Typography  variant="h5" id="Nombre-input"   style={{paddingBottom:.5+'rem',width:35+'rem'}}
                  size="small"             
            >
                {usrSelecc.Status===0 ? '¿Activar Usuario '+Nombre+' ?': '¿Desactivar Usuario '+Nombre+' ?'}  
            </Typography>                        
        </div> 
    )       
    const cerrarBorrar = () => {    
      //setOpen(false);        
      setAviso(false);
      setModalAbierto(false);
      
  };
  return (
  <>           
    <Modal titulo={titulo} modalAbierto={modalAbierto}
      setModalAbierto={setModalAbierto} guardarDatos={guardarDatos}
      mensaje={mensaje} tipoAdvertencia={tipoAdvertencia}
      aviso={aviso} btnDeshabilitado={btnDeshabilitado}
      setAviso={setAviso} tamanio={'sm'} cargando={espera} 
      cerrarBorrar={cerrarBorrar}       
    >
      {DatosGenerales}
    </Modal>         
  </>
  )
}

export default EditarStatusUsu
